import { OptionModel } from "../../common/types/OptionModel";

export const statusOptions: OptionModel[] = [
    {
        value: 0,
        label: "Tümü"
    },
    {
        value: 1,
        label: "Aktif"
    },
    {
        value: 2,
        label: "Pasif"
    }
];